"use strict";
// src/graphql/queries.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_LOCKED_TABLE_DATA = exports.GET_LOCKED_TABLE_DATA_FRAGMENT = exports.GET_RECEIPT_DATA = exports.GET_NFT_HOLDERS = exports.GET_AUTOCOMPOUND_EVENTS = exports.GET_INVESTORS = exports.GET_CETUS_POOLS = exports.GET_POOLS = exports.GET_USER_VAULT_BALANCES = exports.GET_USER_VAULTS = exports.GET_CHAIN_IDENTIFIER = exports.GET_PORTFOLIO_DATA = exports.GET_PROTOCOL_DATA = exports.GET_USER_WALLET_DATA = void 0;
/* This file will contain the GraphQL queries for fetching user wallet
/* data, protocol data, and portfolio data.
 */
const client_1 = require("@apollo/client");
const userVaults_js_1 = require("./queries/userVaults.js");
const userVaultBalances_js_1 = require("./queries/userVaultBalances.js");
const pools_js_1 = require("./queries/pools.js");
const investors_js_1 = require("./queries/investors.js");
const cetusPools_js_1 = require("./queries/cetusPools.js");
const autoCompoundEvents_js_1 = require("./queries/autoCompoundEvents.js");
const nftHolders_js_1 = require("./queries/nftHolders.js");
const receiptData_js_1 = require("./queries/receiptData.js");
const lockedTableDataFragment_js_1 = require("./queries/lockedTableDataFragment.js");
const lockedTableData_js_1 = require("./queries/lockedTableData.js");
// Query to fetch user wallet data
exports.GET_USER_WALLET_DATA = (0, client_1.gql) `
  query GetUserWalletData($address: String!) {
    userWallet(address: $address) {
      coins {
        name
        amount
      }
    }
  }
`;
// Query to fetch protocol data
exports.GET_PROTOCOL_DATA = (0, client_1.gql) `
  query GetProtocolData {
    protocolData {
      totalValueLocked
      pools {
        name
        tvl
      }
    }
  }
`;
// Query to fetch portfolio data
exports.GET_PORTFOLIO_DATA = (0, client_1.gql) `
  query GetPortfolioData($address: String!) {
    portfolio(address: $address) {
      poolName
      investment
    }
  }
`;
exports.GET_CHAIN_IDENTIFIER = (0, client_1.gql) `
  query {
    chainIdentifier
  }
`;
exports.GET_USER_VAULTS = (0, client_1.gql) `
  ${userVaults_js_1.userVaults}
`;
exports.GET_USER_VAULT_BALANCES = (0, client_1.gql) `
  ${userVaultBalances_js_1.userVaultBalances}
`;
exports.GET_POOLS = (0, client_1.gql) `
  ${pools_js_1.pools}
`;
exports.GET_CETUS_POOLS = (0, client_1.gql) `
  ${cetusPools_js_1.cetusPools}
`;
exports.GET_INVESTORS = (0, client_1.gql) `
  ${investors_js_1.investors}
`;
exports.GET_AUTOCOMPOUND_EVENTS = (0, client_1.gql) `
  ${autoCompoundEvents_js_1.autoCompoundEvents}
`;
exports.GET_NFT_HOLDERS = (0, client_1.gql) `
  ${nftHolders_js_1.nftHolders}
`;
exports.GET_RECEIPT_DATA = (0, client_1.gql) `
  ${receiptData_js_1.receiptData}
`;
exports.GET_LOCKED_TABLE_DATA_FRAGMENT = (0, client_1.gql) `
  ${lockedTableDataFragment_js_1.lockedTableDataFragment}
`;
exports.GET_LOCKED_TABLE_DATA = (0, client_1.gql) `
  ${lockedTableData_js_1.lockedTableData}
`;
//# sourceMappingURL=queries.js.map